// extracted by mini-css-extract-plugin
export var container = "aboutme-module--container--irxTl";
export var face = "aboutme-module--face--2mA6F";
export var aboutContent = "aboutme-module--aboutContent--GwWpu";
export var header = "aboutme-module--header--am7Br";
export var underline = "aboutme-module--underline--Kevt1";
export var infoList = "aboutme-module--infoList--TJO6E";
export var normal = "aboutme-module--normal--cawWQ";
export var link = "aboutme-module--link--wrao7";